import { Component, computed, input, OnInit, output, signal } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { RidAssessmentToast, RidMechanicBackground, RidMechanicContent, RidMechanicWrapper, RidTopBar } from '../../components';
import { RidEggCartons } from '../../components/rid-egg-cartons/rid-egg-cartons';
import { AudioEffectPlayer } from '../../utils/audio.utils';

@Component({
  selector: 'rid-flash-amount',
  imports: [RidMechanicBackground, RidMechanicWrapper, RidTopBar, RidMechanicContent, RidAssessmentToast, RidEggCartons],
  templateUrl: './rid-flash-amount.html',
  host: {
    class: 'block',
  },
})
export class RidFlashAmount implements OnInit {
  numbers = input.required<number[]>();
  visibilityDuration = input(2500);
  guessDuration = input(5000);

  index = signal(0);
  number = computed(() => this.numbers()[this.index()]);
  state = signal<'VISIBLE' | 'HIDDEN' | 'ANSWER'>('VISIBLE');

  finished = output<void>();

  async next() {
    const isLastIndex = this.index() === this.numbers().length - 1;

    if (isLastIndex) {
      this.finished.emit();
    } else {
      this.state.set('HIDDEN');
      this.index.set(this.index() + 1);
      await delay(750);
      await this.flash();
    }
  }

  markCorrect() {
    AudioEffectPlayer.play('CORRECT');
    return this.next();
  }

  markIncorrect() {
    AudioEffectPlayer.play('INCORRECT');
    return this.next();
  }

  async ngOnInit() {
    await this.flash();
  }

  async flash() {
    this.state.set('VISIBLE');
    await delay(this.visibilityDuration());
    this.state.set('HIDDEN');
    await delay(this.guessDuration());
    this.state.set('ANSWER');
  }
}
